module.exports = __webpack_public_path__ + "static/media/step-ladders-large@2x.f66b5b3e.png";